import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import type { Interface as ButtonInterface } from '../buttons';
import { Button } from '../buttons';

const Component = (props: ButtonInterface): ReactElement => <Button {...props} />;

export const QuestionnaireButton = styled(Component)(
	({ theme }: { theme: Theme }) => theme.questionnaireField.buttons.sendQuestionnaireButton,
	css`
		box-sizing: border-box;
	`
);
